@if (archiveService.items().length; as archiveItemLength) {
  <div class="archive-item-list">
    @for (item of archiveService.items(); track item.key) {
      <div class="archive-item">
        @if (item.archive.status === 'resizing') {
          <div class="archive-icon-container">
            <app-circle-progress-bar
              [progress]="item.resizeProgress"
              [size]="55"
              [strokeWidth]="12"
              [noBackgroundCircle]="true"
            ></app-circle-progress-bar>
            <img src="/assets/animations/download-resizing.svg" alt="" />
          </div>

          <div class="archive-info">
            <h3>Resizing Images</h3>
            <p>{{ item.assetResizingDoneCount }} of {{ item.assetCount }} images resized.</p>
          </div>
        } @else if (item.completed) {
          <div class="archive-icon-container">
            <img src="/assets/animations/checkmark.svg" alt="" />
          </div>

          <div class="archive-info">
            @if (item.partInfo) {
              <h3>Downloading ZIP {{ item.partInfo.index + 1 }} of {{ item.partInfo.total }}</h3>
            } @else {
              <h3>Download Started</h3>
            }

            <p>{{ item.assetCount }} assets, {{ item.archive.total_size | dataUnitsBigInt: 0 }}.</p>
          </div>
        } @else if (item.progress) {
          <div class="archive-icon-container">
            <app-circle-progress-bar
              [progress]="item.progress"
              [size]="55"
              [strokeWidth]="12"
              [noBackgroundCircle]="true"
            ></app-circle-progress-bar>
            <img src="/assets/animations/download-zipping.svg" alt="" />
          </div>

          <div class="archive-info">
            @if (item.partInfo) {
              <h3>Creating ZIP {{ item.partInfo.index + 1 }} of {{ item.partInfo.total }}</h3>
            } @else {
              <h3>Creating ZIP-File</h3>
            }
            <p>{{ item.progress | number: '1.0-0' }}% of {{ item.archive.total_size | dataUnitsBigInt: 0 }} zipped.</p>
          </div>
        } @else {
          <div class="archive-icon-container">
            <img src="/assets/animations/download-preparing.svg" alt="" />
          </div>

          <div class="archive-info">
            <h3>Preparing Download</h3>
            <p>Collecting {{ item.assetCount }} assets.</p>
          </div>
        }

        @if (!item.completed) {
          <button
            appButton
            name="cancel"
            location="archive-download-info"
            color="simple-gray-60"
            height="1"
            [iconButton]="true"
            shape="round"
            (click)="archiveService.cancelArchive(item)"
          >
            <app-svg src="/assets/icons/stop.svg"></app-svg>
          </button>
        }
      </div>
    }
  </div>
}

<!-- @if (archiveService.items().length; as archiveItemLength) {
  <div class="archive-box" [@archiveBox]>
    <div class="archive-box-header">
      @if (!lastItem()?.completed) {
        <app-loading-indicator size="small"></app-loading-indicator>
      }
      @if (lastItem(); as lastItem) {
        <div class="header-text">
          @if (lastItem.completed) {
            <h3>
              @if (archiveItemLength !== 1) {
                Downloads
              } @else {
                Download
              }
              Ready
            </h3>
          } @else if (lastItem?.archive.status === 'resizing') {
            <h3>
              @if (archiveItemLength !== 1) {
                Resizing ZIP-Files
              } @else {
                Resizing ZIP-File
              }
            </h3>
          } @else {
            <h3>
              @if (archiveItemLength !== 1) {
                Generating ZIP-Files
              } @else {
                Generating ZIP-File
              }
            </h3>
          }
          <div class="size">{{ totalSize() | dataUnitsBigInt: 0 }}</div>
        </div>
      }
      <button
        appButton
        name="toggle-open"
        location="archive-download-info"
        [iconButton]="true"
        color="simple-gray"
        (click)="minimized.set(!minimized())"
      >
        @if (!minimized()) {
          <app-svg src="/assets/icons/chevron-collapse.svg"></app-svg>
        } @else {
          <app-svg src="/assets/icons/chevron-expand.svg"></app-svg>
        }
      </button>
      <button
        appButton
        name="close"
        location="archive-download-info"
        [iconButton]="true"
        color="simple-gray"
        (click)="archiveService.cancelAll()"
      >
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      </button>
    </div>
    @if (!minimized()) {
      <div class="archive-body" [@archiveBody]>
        @for (item of archiveService.items(); track item) {
          <div class="archive-box-item" [@downloadItem]>
            <div class="archive-info">
              <b [appTooltip]="item.archive.zip_name + '.zip'">{{ item.archive.zip_name }}.zip</b>
              @if (item.completed && !item.downloaded) {
                <p>Ready · {{ item.archive.total_size | dataUnitsBigInt: 0 }}</p>
              }
              @if (item.downloaded) {
                <p>Done</p>
              }
              @if (item.errored) {
                <p>Error</p>
              }
              @if (!item.completed && !item.errored) {
                @if (item.archive.status === 'resizing') {
                  <p>Resizing...</p>
                }
                @if (item.archive.status !== 'resizing') {
                  <p>Generating...</p>
                }
              }
            </div>
            <div class="indicator">
              @if (!item.completed && !item.errored) {
                @if (item.progress) {
                  <app-circle-progress-bar [progress]="item.progress" [size]="32" [strokeWidth]="12">
                  </app-circle-progress-bar>
                }
                @if (!item.progress) {
                  <app-loading-indicator stroke="3" [size]="'32'"></app-loading-indicator>
                }
              }
              @if (item.completed && !item.downloaded) {
                <button
                  appButton
                  name="download"
                  location="archive-download-info"
                  color="primary"
                  shape="round"
                  height="1"
                  size="1"
                  (click)="archiveService.downloadArchive(item)"
                >
                  Download
                </button>
              }
              @if (item.downloaded) {
                <div class="check-container">
                  <app-svg src="/assets/icons/check.svg"></app-svg>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
} -->
